import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../components/icon/iconfont'

const concatstr = (...strs) => {
    let filted = strs.filter(s => !!s)
    return filted.join(', ')
}

const getLabel = p => {
    return p?.label || p?.value || ''
}

export default props => {
    useStyles(classes)
    const { address } = props
    const name = address?.firstName ? `${address?.firstName} ${address?.lastName}` : address?.name
    return <div>
        <div>
            <span className={classes.Name}>{name}</span> <span className={classes.Phone}>{address?.phoneNumber}</span>
        </div>
        <div className={classes.Content}>
            <span>{concatstr(address?.streetAddress1, address?.streetAddress2, address?.unit)} </span>
            <span>{concatstr(address?.zipCode, address?.city, getLabel(address?.state), getLabel(address?.country))}</span>
        </div>
    </div>
}